import { useQuery } from '@tanstack/react-query'
import { format } from 'date-fns'
import { apiClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'

interface AnalyticsParams {
  from: Date
  to: Date
  granularity: 'hour' | 'day' | 'week'
  domain?: string
  tag?: string
  transport?: string
}

interface TimeSeriesPoint {
  timestamp: string
  sent: number
  delivered: number
  bounced: number
  complained: number
  opened: number
  clicked: number
  delivery_rate: number
  open_rate: number
  click_rate: number
  bounce_rate: number
  complaint_rate: number
}

interface ISPMetrics {
  domain: string
  sent: number
  delivered: number
  delivery_rate: number
  open_rate: number
}

interface TransportBreakdown {
  transport: string
  count: number
  percentage: number
}

interface AnalyticsResponse {
  timeseries: TimeSeriesPoint[]
  totals: {
    sent: number
    delivered: number
    bounced: number
    complained: number
    opened: number
    clicked: number
    delivery_rate: number
    open_rate: number
    click_rate: number
    bounce_rate: number
    complaint_rate: number
  }
  isp_breakdown: ISPMetrics[]
  transport_breakdown: TransportBreakdown[]
}

export function useAnalytics(
  params: AnalyticsParams,
): ReturnType<typeof useQuery<AnalyticsResponse>> {
  const queryParams = {
    from: format(params.from, 'yyyy-MM-dd'),
    to: format(params.to, 'yyyy-MM-dd'),
    granularity: params.granularity,
    domain: params.domain,
    tag: params.tag,
    transport: params.transport,
  }
  return useQuery({
    queryKey: ['analytics', queryParams],
    queryFn: () => apiClient.get<AnalyticsResponse>(endpoints.analytics(queryParams)),
  })
}

export type { AnalyticsParams, AnalyticsResponse, ISPMetrics, TimeSeriesPoint, TransportBreakdown }
